export enum ConnectorActionCardType {
    None = 'none',
    ConnnectorMessage = 'connectorMessage',
    ExplicitMessageCard = 'explicitMessageCard',
    RecommendationCard = 'recommendationCard',
    AddInRecommendationCard = 'addInRecommendationCard',
    CardHighlight = 'cardHighlight',
    AdaptiveCard = 'adaptiveCard',
    ListViewExtractedAction = 'listViewExtractedAction',
}
